module.exports = __webpack_public_path__ + "components/flag/static/square/be-a28e748f47bd049315d5d4f6d50d5d66.svg";